// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__31QHP","rootSmall":"AddTileButton_rootSmall__2e93b"};